import { withInstall } from '@xzx-design/utils'
import _Steps from './src/steps.vue'
import _Step from './src/step.vue'

export const Steps = withInstall(_Steps)
export default Steps
export const Step = withInstall(_Step)

export * from './src/steps'
export * from './src/step'
